import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as VueGoogleMaps from 'vue2-google-maps'

// Leaflet stuff
import { LMap, LTileLayer, LMarker, LGeoJson } from 'vue2-leaflet';
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-geo-json', LGeoJson)

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
Vue.config.productionTip = false

import Buefy from 'buefy'
Vue.use(Buefy)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY, 
    libraries: 'places',
  },
})

import Axios from 'axios';
Vue.prototype.$axios = Axios;
import store from './store'
Vue.prototype.$store = store
window.store = store

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

if (typeof process.env.VUE_APP_SENTRY_DSN != 'undefined') {  
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({Vue, attachProps: true, })],
  });
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
